// src/features/blog/pages/BlogPage.jsx
import React from "react";
import BlogManager from "../components/BlogManager";
import ErrorBoundary from "../../../components/common/ErrorBoundary";

const BlogPage = () => {
  return (
    <ErrorBoundary>
      <BlogManager />
    </ErrorBoundary>
  );
};

export default BlogPage;
